package com.hyperether.goodjob.scenes.auth

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.hyperether.auth.microsoft.MicrosoftButtonContainer
import com.hyperether.auth.microsoft.MicrosoftButtonMode
import com.hyperether.auth.microsoft.MicrosoftSignInResult

@Composable
actual fun MicrosoftLogin(
    modifier: Modifier,
    mode: MicrosoftButtonMode,
    text: String,
    onResult: (Result<MicrosoftSignInResult?>) -> Unit
) {
    MicrosoftButtonContainer(
        modifier = modifier,
        text = text,
        mode = mode,
        onResult = onResult
    )
}